import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: "open"
        }
    }

    open() {
        let data = {
            img: this.getData('img'),
            rows: this.getData('rows'),
            columns: this.getData('columns')
        }

        this.call('open', data, 'ModalVisualizer')
    }
}
